<template>
  <div>
    <validation-observer v-slot="{ invalid }" v-if="api_response == ''">
      <b-form class="border border-light rounded p-3">
        <b-row>
          <b-col md="6" lg="4">
            <validation-provider
              rules="required|alpha_spaces|min:2"
              name="Nome"
              v-slot="{ errors }"
            >
              <div class="form-group">
                <label>Nome*</label>
                <b-input v-model="firstname" autocomplete="chrome-off" />
                <span class="vee--errors">{{ errors[0] }}</span>
              </div>
            </validation-provider>
          </b-col>

          <b-col md="6" lg="4">
            <validation-provider
              rules="required|alpha_spaces|min:2"
              name="Cognome"
              v-slot="{ errors }"
            >
              <div class="form-group">
                <label>Cognome*</label>
                <b-input v-model="lastname" autocomplete="chrome-off" />
                <span class="vee--errors">{{ errors[0] }}</span>
              </div>
            </validation-provider>
          </b-col>

          <b-col md="6" lg="4">
            <validation-provider rules="alpha_spaces|min:2" name="Azienda" v-slot="{ errors }">
              <div class="form-group">
                <label>Azienda</label>
                <b-input v-model="company" />
                <span class="vee--errors">{{ errors[0] }}</span>
              </div>
            </validation-provider>
          </b-col>

          <b-col md="6" lg="4">
            <validation-provider
              rules="required|email"
              name="E-mail"
              ref="E-mail"
              v-slot="{ errors }"
            >
              <div class="form-group">
                <label>E-mail*</label>
                <b-input v-model="email" autocomplete="chrome-off" />
                <span class="vee--errors">{{ errors[0] }}</span>
              </div>
            </validation-provider>
          </b-col>

          <b-col md="6" lg="4">
            <validation-provider
              rules="required|confirmed:E-mail"
              name="Conferma E-mail"
              v-slot="{ errors }"
            >
              <div class="form-group">
                <label>Conferma E-mail</label>
                <b-input v-model="email_confirm" autocomplete="chrome-off" />
                <span class="vee--errors">{{ errors[0] }}</span>
              </div>
            </validation-provider>
          </b-col>

          <b-col md="6" lg="4" class="d-sm-flex align-items-center">
            <div class="d-flex">
              <b-form-checkbox id="checkbox-disclaimer" v-model="privacy_policy" />
              <label for="checkbox-disclaimer" class="checkbox-label"
                >Ho letto ed accetto la
                <a :href="config.site.urlPrivacy" target="_blank">privacy policy</a></label
              >
            </div>

            <b-button
              v-if="recaptcha_enabled"
              :disabled="invalid || conditions"
              class="btn font-weight-bold btn-tertiary mt-3 mt-sm-0 ml-sm-3"
              @click="recaptcha"
            >
              <span>Richiedi</span>
              <b-spinner v-show="loading" />
            </b-button>

            <b-button
              v-else
              :disabled="invalid || conditions"
              class="btn font-weight-bold btn-tertiary mt-3 mt-sm-0 ml-sm-3"
              @click="request_access()"
            >
              <span>Richiedi</span>
              <b-spinner v-show="loading" />
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <b-row v-else>
      <b-col lg="12">
        <b-alert variant="info" class="text-center" show>
          <strong>{{ api_response }}</strong>
        </b-alert>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import { forms_submitter } from '@/api';
import { custom_event } from '@/utilities';

export default {
  name: 'form-segnalazione-generica',
  components: {},
  props: {
    formTitle: {
      type: String,
      default: '', // titolo del form, renderizzato in alto se != ''
    },
    formSubTitle: {
      type: String,
      default: '', // sottotitolo del form, renderizzato in alto se != ''
    },
    type: {
      type: String,
      default: 'form-segnalazione-generica', // tipo form, usato per distinguere i form e per tracking
    },
    label: {
      type: String,
      default: '', // per distinguere lo stesso form messo in posti diversi, usato anche per tracking
    },
    recipient: {
      type: String,
      default: 'assistenza@vadobay.com', // email destinatario
    },
  },

  data() {
    return {
      config: Vue.prototype.$config,
      firstname: '',
      lastname: '',
      company: '',
      email: '',
      email_confirm: '',
      privacy_policy: false,
      loading: false,
      recaptcha_enabled: Vue.prototype.$config.recaptcha.enabled,
      recaptcha_token: '',
      api_response: '',
    };
  },

  created() {
    this.forms_submitter = forms_submitter;
    this.custom_event = custom_event;
  },

  computed: {
    conditions() {
      return !this.privacy_policy;
    },
  },

  mounted() {
    if (Vue.prototype.$config.recaptcha.enabled) {
      Vue.use(VueReCaptcha, {
        siteKey: Vue.prototype.$config.recaptcha.siteKey,
      });
    }
  },

  methods: {
    async recaptcha() {
      this.loading = true;
      await this.$recaptchaLoaded();
      const token = await this.$recaptcha('form_submitter');
      this.recaptcha_token = token;
      this.request_access();
    },

    request_access() {
      this.loading = true;

      this.forms_submitter({
        recaptcha: this.recaptcha_token,
        fields: {
          firstName: this.firstname,
          lastName: this.lastname,
          company: this.company,
          email: this.email,
        },
        settings: {
          type: this.type,
          label: this.label,
          recipient: this.recipient,
          formTitle: this.formTitle,
          formSubTitle: this.formSubTitle,
        },
      }).then(
        (success) => {
          this.api_response = success.data.msg;
          this.loading = false;
          custom_event('formSubmit', this.type, this.label);
        },
        (error) => {
          this.api_response = error.response.data;
          this.loading = false;
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  width: 100%;

  @include media-breakpoint-up(md) {
    flex-basis: 50%;
  }

  .spinner-border {
    width: 1.3rem;
    height: 1.3rem;
    border-width: 2px;
    margin-left: 5px;
    opacity: 0.3;
    position: relative;
    top: 3px;
  }
}
</style>
